import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';

/**
 * TODO: 迁移至 web-utils 并增加测试
 */
var ERROR_PROMPT = {
  EMAIL: '邮箱不能为空哦~',
  VERIFY_CODE: '验证码不能为空哦~',
  IDENTIFY_CODE_CHECK: '验证码错误~',
  PHONE: '手机号不能为空哦~',
  PASSWORD: '密码不能为空哦~',
  PHONE_CHECK: '手机号格式错误~',
  EMAIL_CHECK: '邮箱地址格式错误~',
  USERNAME: '昵称不能为空哦~',
  MIN_LENGTH: '密码长度最少为 6',
  USERNAME_CHECK: '昵称应为 2-10 个汉字或 4-20 个字母'
}; // TODO: strategies 内部函数由参数列表调整为 obj 的形式

var strategies = {
  isNonEmpty: function isNonEmpty(inputEl, value, errMsg) {
    if (value === '') {
      return {
        inputEl: inputEl,
        errMsg: errMsg
      };
    }

    return false;
  },
  isEmail: function isEmail(inputEl, value, errMsg) {
    if (!/^[^@]+@\w+(\.\w+)+\w$/.test(value)) {
      return {
        inputEl: inputEl,
        errMsg: errMsg
      };
    }

    return false;
  },
  isPhone: function isPhone(inputEl, value, errMsg) {
    if (!/^[0-9]*$/.test(value)) {
      return {
        inputEl: inputEl,
        errMsg: errMsg
      };
    }

    return false;
  },
  minLength: function minLength(inputEl, value, length, errMsg) {
    var realLength = (typeof length === 'string' ? _parseInt(length) : length) || 0;

    if (value.toString().length < realLength) {
      return {
        inputEl: inputEl,
        errMsg: errMsg
      };
    }

    return false;
  },
  isUsername: function isUsername(inputEl, value, errMsg) {
    // eslint-disable-next-line no-control-regex
    var len = value.replace(/[^\x00-\xff]/gi, 'sm').length; // eslint-disable-next-line @typescript-eslint/no-magic-numbers

    if (len > 20 || len < 4) {
      return {
        inputEl: inputEl,
        errMsg: errMsg
      };
    }

    return false;
  },
  isIdentifyCode: function isIdentifyCode(inputEl, value, errMsg) {
    if (!/^[0-9]{6}$/.test(value)) {
      return {
        inputEl: inputEl,
        errMsg: errMsg
      };
    }

    return false;
  }
};
var inputElements = {
  phone: [{
    strategy: 'isPhone',
    errMsg: ERROR_PROMPT.PHONE_CHECK
  }, {
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.PHONE
  }],
  email: [{
    strategy: 'isEmail',
    errMsg: ERROR_PROMPT.EMAIL_CHECK
  }, {
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.EMAIL
  }],
  username: [{
    strategy: 'isUsername',
    errMsg: ERROR_PROMPT.USERNAME_CHECK
  }, {
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.USERNAME
  }],
  password: [{
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.PASSWORD
  }],
  newPassword: [{
    strategy: 'minLength:6',
    errMsg: ERROR_PROMPT.MIN_LENGTH
  }, {
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.PASSWORD
  }],
  verifyCode: [{
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.VERIFY_CODE
  }],
  identifyCode: [{
    strategy: 'isIdentifyCode',
    errMsg: ERROR_PROMPT.IDENTIFY_CODE_CHECK
  }, {
    strategy: 'isNonEmpty',
    errMsg: ERROR_PROMPT.VERIFY_CODE
  }]
};

var Validator = /*#__PURE__*/function () {
  function Validator() {
    _classCallCheck(this, Validator);

    this.cache = [];
    this.errs = {};
  }

  _createClass(Validator, [{
    key: "add",
    value: function add(inputEl, value, rules) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this;

      for (var i = 0; i < rules.length; i++) {

        (function (rule) {
          var strategyArr = rule.strategy.split(':');
          var errMsg = rule.errMsg;
          self.cache.push(function () {
            var strategy = strategyArr.shift();
            strategyArr.unshift(inputEl, value);
            strategyArr.push(errMsg);
            var stragyFn = strategies[strategy];
            return stragyFn.apply(void 0, _toConsumableArray(strategyArr));
          });
        })(rules[i]);
      }
    }
  }, {
    key: "start",
    value: function start() {
      for (var i = 0; i < this.cache.length; i++) {
        var res = this.cache[i]();

        if (res) {
          var inputEl = res.inputEl,
              errMsg = res.errMsg;
          this.errs[inputEl] = errMsg;
        }
      }

      return this.errs;
    }
  }]);

  return Validator;
}(); // TODO: 迁移至 web-utils 中


function validate(els) {
  var validator = new Validator();

  var inputEls = _Object$keys(els);

  inputEls.forEach(function (el) {
    if (el in inputElements) {
      var value = els[el];
      validator.add(el, value, inputElements[el]);
    }
  });
  return validator.start();
}
/**
 * filterPasswordInput 获取当前光标实际位置 selectionPos 示例：
 * 密码输入框 123456
 * 复制 12 3
 * 选中 12【345】6
 * 粘贴后未过滤光标 1212 3光标6 （ref.selectionStart === 6）
 * 过滤后密码长度 6 （121236）
 * 过滤前密码长度 7 （1213 36）
 * 期望光标位置 5
 * 光标实际位置 = 6 +（6 - 7）
 * 即光标实际位置 =（onChange 后 ref.selectionStart 获取未过滤特殊字符密码文本对应的光标位置）+
 * （过滤特殊字符后密码长度 - 过滤前密码长度差值）
 */

var filterPasswordInput = function filterPasswordInput(inputElement) {
  var value = inputElement.value;
  var pwdFilterRegExp = /\s/g;
  var filteredValue = value.replace(pwdFilterRegExp, '');
  var isFiltered = pwdFilterRegExp.test(value);

  if (isFiltered && typeof inputElement.setSelectionRange === 'function' && inputElement.selectionStart !== null) {
    // 计算光标实际位置
    var selectionPos = inputElement.selectionStart + (filteredValue.length - value.length); // 在过滤密码输入框后，重新定位记录的光标位置，否则会在更新过滤后的密码时，光标自动移动到文本最末端

    var restoreSelectionPos = function restoreSelectionPos() {
      inputElement.setSelectionRange(selectionPos, selectionPos);
    };

    return {
      filteredValue: filteredValue,
      isFiltered: isFiltered,
      restoreSelectionPos: restoreSelectionPos
    };
  }

  return {
    filteredValue: filteredValue,
    isFiltered: isFiltered,
    restoreSelectionPos: function restoreSelectionPos() {}
  };
};

export { filterPasswordInput, validate };
